<template>
  <SelectBox
    v-model="receiverId"
    name="Collected By"
    label="Collected By"
    :options="receiverOptions"
    placeholder="Who collected the payment?"
    :validation-errors="v$.$errors"
    class="mb-3"
  />
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import SelectBox from "../components/SelectBox.vue";
import usePaymentMethods from "./usePaymentMethods";

export default {
  components: {
    SelectBox
  },
  props: {
    modelValue: { type: [Number, String], default: null }
  },
  emits: ["update:modelValue"],
  setup() {
    const { receivers } = usePaymentMethods();
    return {
      receivers,
      v$: useVuelidate()
    };
  },
  validations() {
    return {
      receiverId: { required, $autoDirty: true }
    };
  },
  computed: {
    receiverOptions() {
      return this.receivers.map((receiver) => ({
        value: `${receiver.id}_${receiver.type}`,
        label: receiver.full_name
      }));
    },
    receiverId: {
      get() {
        return this.modelValue;
      },
      set(val) {
        return this.$emit("update:modelValue", val);
      }
    }
  }
};
</script>
